import {isString, snakeCase as lodashSnakeCase} from 'lodash';

export const snakeCase = (str: string) => {
  const snake = lodashSnakeCase(str);
  return snake + (str.endsWith('[]') ? '[]' : '');
};

export const stringReplaceAll = (str: string, match: string | RegExp, to: string): string => str.replace(isString(match) ? new RegExp(match, 'g') : match, to);
export const removeSpaces = (str: string) => stringReplaceAll(str, ' ', '');
